var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHardDisk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "nonzero",
    d: "M5.833 33.056V18.472c0-.537.436-.972.973-.972h21.388c.537 0 .973.435.973.972v14.584h1.944c1.074 0 1.945-.871 1.945-1.945V7.208l-5.264-5.264h-2.514v8.75a.972.972 0 0 1-.972.973H10.694a.972.972 0 0 1-.972-.973v-8.75H3.89c-1.074 0-1.945.871-1.945 1.945V31.11c0 1.074.871 1.945 1.945 1.945h1.944zM31.111 35H3.89A3.889 3.889 0 0 1 0 31.111V3.89A3.889 3.889 0 0 1 3.889 0h24.305c.258 0 .506.102.688.285l5.833 5.833c.183.182.285.43.285.688V31.11A3.889 3.889 0 0 1 31.111 35zM11.667 1.944v7.778h11.666V1.944H11.667zm-3.89 17.5v13.612h19.445V19.444H7.778z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardDisk);
export default __webpack_public_path__ + "static/media/hard-disk.f00411c84c58694ca3b1fcfb3e195dd8.svg";
export { ForwardRef as ReactComponent };